import { PayNowActions } from '../actions/actionTypes'
import { PayNowInterface, StatusInterface } from '../Interfaces/PayNow/AccountAuthorizationParams'
import { ReducerBuilder } from './ReducerBuilder'

const initialState: PayNowInterface = {
  loaded: false,
  status: {
    active: true,
    connected: false,
  },
}

const updateStatus = (state: PayNowInterface, payload: StatusInterface): PayNowInterface => ({
  loaded: true,
  status: payload,
})

const disconnect = (state: PayNowInterface, payload: { connected: boolean }): PayNowInterface => {
  return (
    payload &&
    !payload.connected && {
      loaded: true,
      status: {
        active: false,
        connected: false,
      },
    }
  )
}

export default new ReducerBuilder<PayNowInterface, boolean | StatusInterface | { connected: boolean }>(initialState)
  .mapAction(PayNowActions.SAVE_AUTHORIZATION, updateStatus)
  .mapAction(PayNowActions.LOAD_STATUS, updateStatus)
  .mapAction(PayNowActions.UPDATE_STATUS_TOGGLE_ACTIVE, updateStatus)
  .mapAction(PayNowActions.DISCONNECT, disconnect)
  .build()

// Selectors
export const isPayNowConnected = (state): boolean => {
  return state.payNow && state.payNow.status.connected
}

export const isPayNowActive = (state): boolean => {
  return isPayNowConnected(state) && state.payNow.status.active
}
